<div class="drag-area"
     [class.drag-area-active]="dragAreaActive()"
     [class.invisible]="!dragHandleVisible()"
     [@slideInOutLeft]="dragHandleVisible()"
     (mouseenter)="inDragArea.set(true)"
     (mouseleave)="inDragArea.set(false)"
     #drag>
  <div class="drag-handle-extension"
       [@slideInOutLeftChild]="dragHandleVisible()">
  </div>
  <div class="drag-ripple"
       [@slideInOutLeftChild]="dragHandleVisible()"></div>
  <div class="drag-handle"
       [@slideInOutLeftChild]="dragHandleVisible()">
    <mat-icon>drag_indicator</mat-icon>
  </div>
</div>